module.exports = __webpack_public_path__ + "img/point_notstarted.7f178fd2.svg";